import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from '../services/auth.service';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CorporateGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);
  private msalService = inject(MsalService);

  async canActivate(): Promise<boolean | UrlTree> {
    try {
      return this.authService.isCorporateAgent() || this.authService.isAdmin();
    } catch {
      return false;
    }
  }

}
